module.exports = __webpack_public_path__ + "static/img/phone.20590178.png";